<template>
  <div>
    <fieldset class="border p-3">
      <legend>
        <small style="font-size:15px; font-weight: bold">Invoice</small>
      </legend>
      <div>
        <div class="row">
          <div class="col-md-12">
            <fieldset class="border p-3">
              <div class="row">
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Customer name:</label>
                  <span style="font-size:13px;">{{Fileopening.customer_name}}</span>
                </div>
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Bol:</label>
                  <span style="font-size:13px;">{{Fileopening.bill_landing}}</span>
                </div>
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Good description:</label>
                  <span style="font-size:13px;">{{Fileopening.description}}</span>
                </div>
              </div>
              
            </fieldset>
          </div>
        </div>
        <form @submit.prevent="newInvoice()">
          <div class="row">
            <input type="hidden" class="fileopening_id" :value="Fileopening.id" />
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Description</th>
                      <th scope="col text-right">Unit price</th>
                      <th scope="col">Quantity</th>
                      <th scope="col text-right">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(invoice_product, k) in invoiceproductRows" :key="k">
                      <td scope="row">
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="deleteRow(k, invoice_product)"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                        <!-- <i class="fa fa-trash-alt" @click="deleteRow(k, invoice_product)"></i> -->
                      </td>
                      <td>
                        <input
                          class="form-control input-rounded f-s-14"
                          type="text"
                          v-model="invoice_product.description"
                        />
                      </td>
                      <td>
                        <input
                          class="form-control input-rounded f-s-14"
                          type="number"
                          min="0"
                          step=".01"
                          v-model="invoice_product.unit_price"
                          @change="calculateLineTotal(invoice_product)"
                        />
                      </td>
                      <td>
                        <input
                          class="form-control input-rounded f-s-14"
                          type="number"
                          min="0"
                          step=".01"
                          v-model="invoice_product.qty"
                          @change="calculateLineTotal(invoice_product)"
                        />
                      </td>
                      <td>
                        <input
                          readonly
                          class="form-control text-right input-rounded f-s-14"
                          type="number"
                          min="0"
                          step=".01"
                          v-model="invoice_product.total_price"
                        />
                      </td>
                    </tr>
                    <tr v-show="invoiceproductRows.length === 0">
                      <td colspan="6">
                        <p class="text-center alert-danger p-2">No products added/available.</p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="4" class="text-right">Sub Total</td>
                      <input
                        readonly
                        class="form-control text-right sub_total input-rounded f-s-14"
                        type="number"
                        min="0"
                        step=".01"
                        :value="invoice_subtotal"
                      />
                    </tr>
                    <tr>
                      <td colspan="4" class="text-right">Total</td>
                      <input
                        readonly
                        class="form-control text-right grand_total input-rounded f-s-14"
                        type="number"
                        min="0"
                        step=".01"
                        :value="invoice_total"
                      />
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="col-md-12 mb-2">
              <button type="button" class="btn btn-info" @click="addInvoiceProduct">
                <i class="fa fa-plus-circle"></i>
                Add
              </button>
            </div>
            <button type="submit" class="btn btn-primary btn-flat creatingInvoice btn-rounded">
            <i class="fa fa-plus"></i> create invoice
          </button>
          <button type="button" class="btn-rounded btn-flat creatingInvoiceLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
          </div>
        </form>
      </div>
    </fieldset>
  </div>
</template>
 <script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import router from "../router/index";
export default {
  data() {
    return {
      invoice_subtotal: 0,
      invoice_total: 0,
      tax_total: 0,
      invoice_tax: 16
    };
  },
  created() {
    if (this.$store.getters.Fileopening.length === 0) {
      router.push("/managefileinvoicing");
    }
  },
  computed: {
    ...mapGetters(["Fileopening", "invoiceproductRows"])
  },

  methods: {
    ...mapActions(["newInvoice"]),
    ...mapMutations(["addInvoiceProduct"]),
    calculateTotal() {
      var subtotal, total, totals;
      subtotal = this.invoiceproductRows.reduce(function(sum, product) {
        var lineTotal = parseFloat(product.total_price);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);

      if (!isNaN(subtotal)) {
        this.invoice_subtotal = subtotal.toFixed(2);
      } else {
        this.invoice_subtotal = "0.00";
      }
      total = subtotal ;
      total = parseFloat(total);
      if (!isNaN(total)) {
        this.invoice_total = total.toFixed(2);
      } else {
        this.invoice_total = "0.00";
      }
    },
    calculateLineTotal(invoice_product) {
      var total =
        parseFloat(invoice_product.unit_price) *
        parseFloat(invoice_product.qty);
      if (!isNaN(total)) {
        invoice_product.total_price = total.toFixed(2);
      }
      this.calculateTotal();
    },
    deleteRow(index, invoice_product) {
      var idx = this.invoiceproductRows.indexOf(invoice_product);
      console.log(idx, index);
      if (idx > -1) {
        this.invoiceproductRows.splice(idx, 1);
      }
      this.calculateTotal();
    }
  }
};
</script>
<style scoped>
.creatingInvoiceLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/invoices/invoice.vue